import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Sortable from 'react-sortablejs';
import cx from 'classnames';

import ImageControls from '../HelpComponents/ImageControls';
import ImageWrapper from '../HelpComponents/ImageWrapper';
import OMTextArea from '../../OMComponents/OMTextArea/OMTextArea';
import * as styles from '../UploadAssetWidget.scss';
import { MEDIA_CONTENT_TYPE } from '../../../constants';
import { computeMediaHasFailed, computeMediaIsPending } from '../../../utils/normalizeMediaStatus';
import VideoUploadService from '../../../services/VideoUploadService';
import ImageUploadService from '../../../services/ImageUploadService';
import getVideoProcessingLabelKey from '../../../utils/getVideoProcessingLabelKey';
import getImageProcessingLabelKey from '../../../utils/getImageProcessingLabelKey';

export default class PreviewList extends Component {
  sortableOptions = {
    ghostClass: styles.sortableGhost,
    animation: 150,
    forceFallback: true,
    onStart: () => {
      document.querySelector(`.${styles.fileUpload}`).classList.add(styles.noTransition);
      document.body.classList.add(styles.dragOnBody);
    },
    onEnd: () => {
      document.querySelector(`.${styles.fileUpload}`).classList.remove(styles.noTransition);
      document.body.classList.remove(styles.dragOnBody);
    }
  };

  sortableOnChange = (order, sortableInstance, evt) => {
    this.props.onChange(order);
    const descriptionFields = evt.target.querySelectorAll('textarea');
    if (descriptionFields) {
      for (let index = 0; index < descriptionFields.length; index += 1) {
        descriptionFields[index].value = this.props.items[index].description || null;
      }
    }
  };

  fetchMediaStatus = (isVideo, item) => () => (isVideo
    ? VideoUploadService.getStatus({ videoId: item.videoId })
    : ImageUploadService.getStatus({ imageId: item.imageId }));

  handleAssetSettled = (id, key) => statusData => this.props.onAssetSettled?.(id, key, statusData);

  renderListItems = (items) => {
    if (!items || (items && !items.length)) {
      return null;
    }

    return items.map((item, index) => {
      const isVideo = (item.contentType === MEDIA_CONTENT_TYPE.VIDEO);
      const isRaw = item.type === 'application/pdf' || item.raw;

      return (
        <div
          className={cx(
            styles.imageContainer,
            { [styles.videoList]: isVideo },
            { [styles.mainImage]: !index }
          )}
          key={item._id}
          data-id={index}
        >
          <ImageControls
            isTabletDevice={this.props.isTabletDevice}
            mainImageTitle={(!index) && (
              <div className={styles.mainImageTitle}>{this.props.translate('mainImage')}</div>
            )}
            deleteFileTitle={this.props.translate('deleteFile')}
            rotateImageTitle={this.props.translate('rotateImage')}
            deleteImage={evt => this.props.deleteItem(evt, index, item)}
            rotateImage={evt => this.props.rotateImage(evt, index, item)}
            isVideo={isVideo}
            isRaw={isRaw}
          />

          <ImageWrapper
            id={item._id}
            image={(item.thumbnail) ? item.thumbnail : null}
            angle={item.relativeAngle || 0}
            uploadInProgress={!!item.preview}
            isVideo={isVideo}
            isRaw={isRaw}
            mediaId={isVideo ? item.videoId : item.imageId}
            fetchStatus={this.fetchMediaStatus(isVideo, item)}
            getLabelKey={isVideo ? getVideoProcessingLabelKey : getImageProcessingLabelKey}
            isPending={computeMediaIsPending(item)}
            hasError={computeMediaHasFailed(item)}
            onMediaStatusChange={this.handleAssetSettled(item._id, isVideo ? 'videos' : 'images')}
          />
          {isRaw
            ? <div className={styles.nameWrapper}>
                <p>
                  {item.name}
                </p>
              </div>
            : <OMTextArea
              disabled={this.props.uploadInProgress}
              onBlur={event => this.props.addDescription?.(event.target.value, index, item)}
              maxLength="24"
              placeholder={this.props.translate('imageDescription')}
              initialValue={item.description}
            />
          }
        </div>
      );
    });
  };

  render() {
    if (this.sortable) {
      this.sortable.option('disabled', this.props.uploadInProgress);
    }

    return (
      <div className={styles.previewList}>
        { this.renderListItems(this.props.videos) }
        <Sortable
          className={styles.sortableList}
          options={this.sortableOptions}
          onChange={this.sortableOnChange}
          ref={(component) => { if (component) { this.sortable = component.sortable; } }}
        >
          { this.renderListItems(this.props.items) }
        </Sortable>
      </div>
    );
  }
}

PreviewList.propTypes = {
  items: PropTypes.array,
  videos: PropTypes.array,
  onChange: PropTypes.func,
  deleteItem: PropTypes.func,
  uploadInProgress: PropTypes.bool,
  translate: PropTypes.func,
  addDescription: PropTypes.func,
  rotateImage: PropTypes.func,
  onAssetSettled: PropTypes.func,
  isTabletDevice: PropTypes.bool,
  isMobile: PropTypes.bool
};
